import Vue from 'vue'
import { BaseApi } from '@/api/base-api'
import { RESOURCE_LOG_IMPORTS } from '@/shared/constants/resources'

class LogImportsApi extends BaseApi {
    constructor(resource) {
      super(resource)
      this.resource = resource
    }
    fetchLogImport (uuid) {
      return new Promise(async (resolve, reject) => {
        try {
          console.log("Fetching log import with uuid:", uuid);
          const response = await Vue.prototype.$http.post(`/${this.resource}/run`, { "uuid": uuid })
          Vue.$toast('Importación lanzada con éxito.')
          resolve(response.data)
        } catch (error) {
          Vue.$toast.error('Ocurrió un error al lanzar la importación.')
          reject(error)
        }
      })
    }
}

export default new LogImportsApi(RESOURCE_LOG_IMPORTS)